import React, { useState, useEffect } from 'react';
import './MisPay.css';
import { useLocation, useNavigate } from 'react-router-dom'; 
import axios from 'axios';
import { toast } from 'react-toastify';

const MisPay = () => {
  const location = useLocation();
  const navigate = useNavigate(); 
  const acc = location.state?.acc; 

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false); 
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [formData, setFormData] = useState({
    payoutMode: 'Auto',
    narration: '',
    postedDate: new Date().toISOString().split('T')[0]
  });

  useEffect(() => {
    if (!acc) {
      toast.error("Account details missing. Redirecting...");
      navigate("/FdMisReport"); 
    }
  }, [acc, navigate]);

  const fetchTransactionData = async () => {
    if (!acc) return;
    setLoading(true);
    try {
      const response = await axios.get(
        `https://payyug.in/api/all-saving-account/transaction-all?accountId=${acc.id}&accountType=${acc.accountType}`
      );
      setData(response?.data?.statement || []);
    } catch (error) {
      console.error("Error fetching report:", error);
      toast.error("Failed to load transactions");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (acc) fetchTransactionData();
  }, [acc]);

  const handlePay = async () => {
    try {
      const payload = {
        accountId: acc.id,
        postedBy: localStorage.getItem("adminuserId"),
        payoutMode: formData.payoutMode,
        narration: formData.narration,
        postedDate: formData.postedDate
      };
      
      const response = await axios.post(`https://payyug.in/api/mis/pay`, payload);
      if(response?.data?.success===true){
        toast.success(response?.data?.message || "Payment successful!");
        await fetchTransactionData();
        setIsModalOpen(false);
      }
    } catch (error) {
      toast.error(error?.response?.data?.message || "Error posting payment");
    }
  };

  if (!acc) return null;

  return (
    <div className="mis-pay-container">
      <div className="mis-pay-header-card">
        <h2 className="mis-pay-header-title">Mis Payment Schedule</h2>
        <div className="mis-pay-account-details">
          <p><strong>Account No:</strong> {acc.accountNumber || "N/A"}</p>
          <p><strong>Account Type:</strong> {acc.accountType || "N/A"}</p>
          <p><strong>Customer:</strong> {acc?.customer?.fullName || "N/A"}</p>
        </div>
      </div>

      <div className="mis-pay-action-toolbar">
        <button className="mis-pay-btn" onClick={() => setIsModalOpen(true)}>
          Pay
        </button>
      </div>

      <div className="mis-pay-data-container">
        {loading ? (
          <p className="text-center p-4">Loading transactions...</p>
        ) : (
          <table className="mis-pay-data-table">
            <thead>
              <tr>
                <th>S.No</th>
                <th>Txn Type</th>
                <th>Amount</th>
                <th>Payment Mode</th>
                <th>Refrence No</th>
                <th>Balance After Txn</th>
                <th>Txn Date</th>
                <th>Remark</th>
                <th>Status</th>
              </tr>
            </thead>
            <tbody>
              {data.length > 0 ? (
                data.map((row, index) => (
                  <tr key={index}>
                    <td>{index + 1}</td>
                    <td>{row.txnType || "N/A"}</td>
                    <td>{row.amount ? `₹${row.amount}` : "N/A"}</td>
                    <td>{row.paymentMode || "N/A"}</td>
                    <td>{row.referenceNo || "N/A"}</td>
                    <td>{row.balanceAfterTxn ? `₹${row.balanceAfterTxn}` : "N/A"}</td>
                    <td>{row.txnDate ? new Date(row.txnDate).toLocaleDateString("en-GB") : "N/A"}</td>
                    <td>{row.remarks || "N/A"}</td>
                    <td>{row.status || "N/A"}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="9" style={{ textAlign: 'center' }}>No transactions found</td>
                </tr>
              )}
            </tbody>
          </table>
        )}
      </div>
      {/* Modal / Popup */}
      {isModalOpen && (
        <div className="mis-pay-modal-overlay">
          <div className="mis-pay-modal-content">
            <h3>Payment Details</h3>
            
            <div className="mis-pay-modal-form-group">
              <label className="mis-pay-modal-form-label">Monthly Interest</label>
              <input 
                className="mis-pay-modal-form-input" 
                type="text" 
                value={acc.monthlyInterest} 
                readOnly 
              />
            </div>
            <div className="mis-pay-modal-form-group">
              <label className="mis-pay-modal-form-label">Payout Mode</label>
              <input 
                className="mis-pay-modal-form-input" 
                type="text" 
                value={formData.payoutMode} 
                readOnly 
              />
            </div>

            <div className="mis-pay-modal-form-group">
              <label className="mis-pay-modal-form-label">Narration</label>
              <input 
                className="mis-pay-modal-form-input" 
                type="text" 
                value={formData.narration}
                onChange={(e) => setFormData({...formData, narration: e.target.value})}
              />
            </div>

            <div className="mis-pay-modal-form-group">
              <label className="mis-pay-modal-form-label">Posted Date</label>
              <input 
                className="mis-pay-modal-form-input" 
                type="date" 
                value={formData.postedDate}
                onChange={(e) => setFormData({...formData, postedDate: e.target.value})}
              />
            </div>

            <div className="mis-pay-modal-actions">
              <button onClick={() => setIsModalOpen(false)}>Cancel</button>
              <button className="mis-pay-btn" onClick={handlePay}>Submit</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default MisPay;